import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Maincomponent from "../../Components/Maincomponent/Maincomponent";
import { Select } from "antd";

import { Input } from "antd";
import Button from "react-bootstrap/Button";
import Apiurl from "../../Apiurl";
import axios from "axios";
import { Tabhelper } from "../../Helper/Tabhelper";
import Staffroleoptions from "../../Options/Staffroleoptions";

export default function Employeeupdate() {
  const apiurl = Apiurl();
  let dollarIndianLocale = Intl.NumberFormat("en-IN", {
    minimumFractionDigits: 2,
  });
  const [show, setShow] = useState(false);
  const roleoptions = Staffroleoptions();
  const { Id } = useParams();

  const [studentImage, setStudentImage] = useState(null);

  const [referencedata, setreferencedata] = useState([]);
  const [totalcount, settotalcount] = useState(0);

  const [isverified, setisverified] = useState(true);
  const [stduid, setstduid] = useState(null);
  const [snonumber, setsnonumber] = useState(0);

  const [subjectoptions, setsubjectoptions] = useState([]);

  const { user } = useParams();
  let navigate = useNavigate();

  const aduser = window.localStorage.getItem("userid");
  const [formData, setFormData] = useState({
    Name: "",
    first_name: "",
    last_name: "",
    dob: null,
    gender: "",
    contactnumber: "",
    alternativenumber: "",
    Email: "",
    address: "",
    pincode: "",
    district: "",
    state: "",
    nationality: "",
    accountnumber: "",
    accountholdername: "",
    bankname: "",
    branch: "",
    ifsccode: "",
    Role: "",
    Designation: "",
    employementtype: "",
    joindate: null,
    Staffid: "",
    Status: "",
    notification_token: "",
    usertype: "",
  });

  const personalitem = [
    {
      name: "first_name",
      placeholder: "First Name",
      type: "inputtext",
      isrequired: true,
      Label: "First Name",
      options: [],
      isdisabled: false,
    },
    {
      name: "last_name",
      type: "inputtext",
      Label: "Last Name",
      isrequired: true,
      placeholder: "Last Name",
      options: [],
      isdisabled: false,
    },

    {
      name: "dob",
      placeholder: "Date Of Birth",
      type: "inputdate",
      Label: "Date Of Birth",
      options: [],
      isdisabled: false,
      isrequired: true,
    },
    {
      name: "gender",
      placeholder: "Gender",
      type: "inputdrop",
      Label: "Gender",
      options: [
        {
          value: "Male",
          label: "Male",
        },
        {
          value: "Female",
          label: "Female",
        },
        {
          value: "Transgender",
          label: "Transgender",
        },
      ],
      isdisabled: false,
      isrequired: true,
    },
    {
      name: "contactnumber",
      type: "inputtext",
      placeholder: "Contact Number",
      Label: "Contact Number",
      options: [],
      isdisabled: false,
      isrequired: true,
    },
    {
      name: "alternativenumber",
      type: "inputtext",
      Label: "Alternative Number",
      options: [],
      placeholder: " Parent Number",
      isdisabled: false,
      isrequired: true,
    },
    {
      name: "Email",
      type: "inputtext",
      Label: "Email",
      placeholder: "Email",
      options: [],
      isdisabled: false,
      isrequired: false,
    },

    {
      name: "address",
      type: "inputtext",
      placeholder: "Address",
      Label: "Address",
      options: [],
      isdisabled: false,
      isrequired: false,
    },
    {
      name: "pincode",
      type: "inputtext",
      placeholder: "Pincode",
      Label: "Pincode",
      options: [],
      isdisabled: false,
      isrequired: false,
    },

    {
      name: "district",
      type: "inputtext",
      Label: "District",
      placeholder: "District",
      options: [],
      isdisabled: false,
      isrequired: false,
    },

    {
      name: "state",
      type: "inputtext",
      Label: "State",
      placeholder: "State",
      options: [],
      isdisabled: false,
      isrequired: false,
    },
    // {
    //   name: "religion",
    //   type: "inputdrop",
    //   Label: "Religion",
    //   placeholder: "Religion",
    //   options: [
    //     {
    //       name: "Christian",
    //       value: "Christian",
    //     },
    //     {
    //       name: "Hindu",
    //       value: "Hindu",
    //     },
    //     {
    //       name: "Muslim",
    //       value: "Muslim",
    //     },
    //     {
    //       name: "Other",
    //       value: "Other",
    //     },
    //   ],
    //   isdisabled: false,
    //   isrequired: true,
    // },

    {
      name: "nationality",
      type: "inputtext",
      placeholder: "Nationality",
      Label: "Nationality",
      options: [],
      isdisabled: false,
      isrequired: false,
    },
  ];
  const phasetwo = [
    // {
    //   name: "standard",
    //   type: "inputdrop",
    //   placeholder: "Account Number",
    //   Label: "Account Number",
    //   options: [
    //     {
    //       value: "Class 4",
    //       label: "Class 4",
    //     },
    //     {
    //       value: "Class 5",
    //       label: "Class 5",
    //     },
    //     {
    //       value: "Class 6",
    //       label: "Class 6",
    //     },
    //     {
    //       value: "Class 7",
    //       label: "Class 7",
    //     },
    //     {
    //       value: "Class 8",
    //       label: "Class 8",
    //     },
    //     {
    //       value: "Class 9",
    //       label: "Class 9",
    //     },
    //     {
    //       value: "Class 10",
    //       label: "Class 10",
    //     },
    //     {
    //       value: "Class 11",
    //       label: "Class 11",
    //     },
    //     {
    //       value: "Class 12",
    //       label: "Class 12",
    //     },
    //   ],
    //   isdisabled: false,
    //   isrequired: false,
    // },
    // {
    //   name: "board",
    //   type: "inputdrop",
    //   placeholder: "Account Holder Name",
    //   Label: "Account Holder Name",
    //   options: [
    //     {
    //       value: "SB",
    //       label: "SB",
    //     },
    //     {
    //       value: "CBSE",
    //       label: "CBSE",
    //     },
    //     {
    //       value: "ICSE",
    //       label: "ICSE",
    //     },
    //   ],
    //   isdisabled: false,
    //   isrequired: false,
    // },
  ];
  const phasethree = [
    {
      name: "accountnumber",
      type: "inputtext",
      Label: "Account Number",
      placeholder: "Account Number",
      options: [],
      isdisabled: false,
      isrequired: true,
      isvisible: true,
      isamount: false,
    },
    {
      name: "accountholdername",
      type: "inputtext",
      Label: "Account Holder Name",
      placeholder: "Account Holder Name",
      options: [],
      isdisabled: false,
      isrequired: true,
      isvisible: true,
      isamount: false,
    },
    {
      name: "bankname",
      type: "inputtext",
      Label: "Bank Name",
      placeholder: "Bank Name",
      options: [],
      isdisabled: false,
      isrequired: true,
      isvisible: true,
      isamount: false,
    },
    {
      name: "branch",
      type: "inputtext",
      Label: "Branch",
      placeholder: "Branch",
      options: [],
      isdisabled: false,
      isrequired: true,
      isvisible: true,
      isamount: false,
    },
    {
      name: "ifsccode",
      type: "inputtext",
      Label: "IFSC Code",
      placeholder: "IFSC Code",
      options: [],
      isdisabled: false,
      isrequired: true,
      isvisible: true,
      isamount: false,
    },
    {
      name: "Role",
      type: "inputdrop",
      Label: "Role",
      placeholder: "Role",
      options: roleoptions,
      isdisabled: false,
      isrequired: true,
      isvisible: true,
      isamount: false,
    },
    {
      name: "Designation",
      type: "inputtext",
      Label: "Designation",
      placeholder: "Designation",
      options: roleoptions,
      isdisabled: false,
      isrequired: true,
      isvisible: true,
      isamount: false,
    },

    {
      name: "employementtype",
      type: "inputdrop",
      Label: "Employeement Type",
      options: [
        {
          value: "Full-Time",
          label: "Full-Time",
        },
        {
          value: "Part-Time",
          label: "Part-Time",
        },
        {
          value: "Contract",
          label: "Contract",
        },
        {
          value: "Freelancers ",
          label: "Freelancers ",
        },
        {
          value: "Internship ",
          label: "Internship ",
        },
        {
          value: "Remote Work",
          label: "Remote Work",
        },
        {
          value: "Consultants",
          label: "Consultants",
        },
      ],
      placeholder: "Employeement Type",
      isdisabled: false,
      isrequired: true,
      isvisible: true,
      isamount: false,
    },

    {
      name: "joindate",
      type: "inputdate",
      Label: "Join Date",
      placeholder: "Join Date",
      options: [],
      isdisabled: false,
      isrequired: true,
      isvisible: true,
      isamount: false,
    },
    {
      name: "Status",
      type: "inputdrop",
      placeholder: "Status",
      Label: "Status",
      options: [
        { label: "Active", value: "Active" },
        { label: "Resigned", value: "Resigned" },
        { label: "Relieved", value: "Relieved" },
      ],
      isdisabled: false,
      isrequired: true,
      isvisible: true,
      isamount: false,
    },

    {
      name: "Staffid",
      type: "inputtext",
      placeholder: "Employee ID",
      Label: "Employee ID",
      options: [],
      isdisabled: true,
      isrequired: true,
      isvisible: true,
      isamount: false,
    },
    // {
    //   name: "sno",
    //   type: "inputtext",
    //   placeholder: "S.No",
    //   Label: "S.No",
    //   options: [],
    //   isdisabled: true,
    //   isrequired: true,
    //   isvisible: true,
    //   isamount: false,
    // },
  ];

  const [currentStep, setCurrentStep] = useState(1);

  const handleChange = (name, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.put(
        apiurl + `staffdetails/${Id}/`,
        formData
      );
      console.log(response.data);
      alert("Updated");
      navigate(`/staff_profile/${user}`);
    } catch (error) {
      alert("ERROR");
      console.log(error);
    }
  };

  const Formfooter = () => {
    return (
      <>
        <div className="multiformfooter">
          <Button
            onClick={() => {
              setCurrentStep(1);
              setisverified(false);
            }}
            size="sm"
            variant={currentStep == 1 ? "primary" : "outline-primary"}
          >
            Personal
          </Button>
          &nbsp;&nbsp;&nbsp;
          {/* <Button
            onClick={() => {
              setCurrentStep(2);
              setisverified(false);
            }}
            size="sm"
            variant={currentStep == 2 ? "primary" : "outline-primary"}
          >
            Bank
          </Button>
          &nbsp;&nbsp;&nbsp; */}
          <Button
            onClick={() => {
              setCurrentStep(3);
              setisverified(false);
            }}
            size="sm"
            variant={currentStep == 3 ? "primary" : "outline-primary"}
          >
            Office
          </Button>
          {currentStep == 3 && (
            <>
              {" "}
              &nbsp;&nbsp;&nbsp;{" "}
              <Button
                onClick={generateID}
                size="sm"
                variant={isverified ? "success" : "outline-success"}
              >
                Verify
              </Button>
              &nbsp;&nbsp;&nbsp;{" "}
              {isverified && (
                <Button
                  onClick={handleSubmit}
                  size="sm"
                  variant="outline-success"
                >
                  Confirm
                </Button>
              )}
            </>
          )}
        </div>
      </>
    );
  };

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <div className="multistepmaincontainer">
            <div className="multistephead">
              {" "}
              <b>PERSONAL DETAILS</b>
            </div>
            <div className="multistepcontainer1">
              <div className="multistepsubcontainer1">
                <div className="multisteptable">
                  {/* ... (your existing code) */}
                  {personalitem.map((item, index) => (
                    <div className="multisteptablerow" key={index}>
                      <div className="multisteptablecell1">
                        {item.Label}
                        <span style={{ color: "red" }}>
                          {" "}
                          {item.isrequired ? "*" : null}{" "}
                        </span>
                      </div>
                      <div className="multisteptablecell2">
                        {item.type === "inputtext" ? (
                          <Input
                            type="text"
                            name={item.name}
                            placeholder={item.placeholder}
                            value={formData[item.name]}
                            onChange={(e) =>
                              handleChange(item.name, e.target.value)
                            }
                          />
                        ) : item.type === "inputdate" ? (
                          <>
                            {" "}
                            <Input
                              type="date"
                              name={item.name}
                              placeholder={item.placeholder}
                              value={formData[item.name]}
                              onChange={(e) =>
                                handleChange(item.name, e.target.value)
                              }
                            />
                          </>
                        ) : (
                          <>
                            <Select
                              showSearch
                              style={{
                                width: "100%",
                              }}
                              placeholder={item.placeholder}
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                (option?.label ?? "").includes(input)
                              }
                              filterSort={(optionA, optionB) =>
                                (optionA?.label ?? "")
                                  .toLowerCase()
                                  .localeCompare(
                                    (optionB?.label ?? "").toLowerCase()
                                  )
                              }
                              value={formData[item.name] || undefined}
                              onChange={(value) =>
                                handleChange(item.name, value)
                              }
                              options={item.options}
                            />
                          </>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            {/* <div className="multiformfooter">
              <button className="multiformbtn" onClick={nextStep}>
                Next
              </button>
            </div> */}
            <Formfooter />
          </div>
        );
      case 2:
        return (
          <div className="multistepmaincontainer">
            <div className="multistephead">
              {" "}
              <b>BANK DETAILS</b>
            </div>
            <div className="multistepcontainer1">
              <div className="multistepsubcontainer1">
                <div className="multisteptable">
                  {phasetwo.map((item, index) => (
                    <div className="multisteptablerow" key={index}>
                      <div className="multisteptablecell1">
                        {item.Label}
                        <span style={{ color: "red" }}>
                          {" "}
                          {item.isrequired ? "*" : null}{" "}
                        </span>
                      </div>
                      <div className="multisteptablecell2">
                        {item.type === "inputtext" ? (
                          <Input
                            type="text"
                            name={item.name}
                            placeholder={item.placeholder}
                            value={formData[item.name]}
                            onChange={(e) =>
                              handleChange(item.name, e.target.value)
                            }
                          />
                        ) : item.type === "inputdate" ? (
                          <>
                            {" "}
                            <Input
                              type="date"
                              name={item.name}
                              placeholder={item.placeholder}
                              value={formData[item.name]}
                              onChange={(e) =>
                                handleChange(item.name, e.target.value)
                              }
                            />
                          </>
                        ) : (
                          <>
                            <Select
                              showSearch
                              style={{
                                width: "100%",
                              }}
                              placeholder={item.placeholder}
                              optionFilterProp="children"
                              filterOption={(input, option) =>
                                (option?.label ?? "").includes(input)
                              }
                              filterSort={(optionA, optionB) =>
                                (optionA?.label ?? "")
                                  .toLowerCase()
                                  .localeCompare(
                                    (optionB?.label ?? "").toLowerCase()
                                  )
                              }
                              value={formData[item.name] || undefined}
                              onChange={(value) =>
                                handleChange(item.name, value)
                              }
                              options={item.options}
                            />
                          </>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            {/* <div className="multiformfooter">
              <button className="multiformbtn" onClick={prevStep}>
                Previous
              </button>
              &nbsp;&nbsp;&nbsp;
              <button className="multiformbtn" onClick={nextStep}>
                Next
              </button>
            </div> */}
            <Formfooter />
          </div>
        );
      case 3:
        return (
          <div className="multistepmaincontainer">
            <div className="multistephead">
              {" "}
              <b>OFFICE USE</b>
            </div>

            <div className="multistepcontainer1">
              <div className="multistepsubcontainer1">
                <div className="multisteptable">
                  {phasethree.map((item, index) => (
                    <>
                      {item.isvisible ? (
                        <div className="multisteptablerow" key={index}>
                          <div className="multisteptablecell1">
                            {item.Label}
                            <span style={{ color: "red" }}>
                              {" "}
                              {item.isrequired ? "*" : null}{" "}
                            </span>
                          </div>
                          <div className="multisteptablecell2">
                            {item.type === "inputtext" ? (
                              <Input
                                type="text"
                                name={item.name}
                                placeholder={item.placeholder}
                                value={
                                  item.isamount
                                    ? dollarIndianLocale.format(
                                        formData[item.name]
                                      )
                                    : formData[item.name]
                                }
                                disabled={item.isdisabled}
                                onChange={(e) =>
                                  handleChange(item.name, e.target.value)
                                }
                              />
                            ) : item.type === "inputdate" ? (
                              <Input
                                type="date"
                                name={item.name}
                                placeholder={item.placeholder}
                                value={formData[item.name]}
                                onChange={(e) =>
                                  handleChange(item.name, e.target.value)
                                }
                              />
                            ) : item.type === "multiselectdrop" ? (
                              <Select
                                mode="multiple"
                                showSearch
                                style={{
                                  width: "100%",
                                }}
                                placeholder={item.placeholder}
                                optionFilterProp="children"
                                disabled={item.isdisabled}
                                filterOption={(input, option) =>
                                  (option?.label ?? "").includes(input)
                                }
                                filterSort={(optionA, optionB) =>
                                  (optionA?.label ?? "")
                                    .toLowerCase()
                                    .localeCompare(
                                      (optionB?.label ?? "").toLowerCase()
                                    )
                                }
                                value={formData[item.name] || []}
                                onChange={(value) =>
                                  handleChange(item.name, value)
                                }
                                options={item.options}
                              />
                            ) : (
                              <Select
                                showSearch
                                style={{
                                  width: "100%",
                                }}
                                placeholder={item.placeholder}
                                optionFilterProp="children"
                                disabled={item.isdisabled}
                                filterOption={(input, option) =>
                                  (option?.label ?? "").includes(input)
                                }
                                filterSort={(optionA, optionB) =>
                                  (optionA?.label ?? "")
                                    .toLowerCase()
                                    .localeCompare(
                                      (optionB?.label ?? "").toLowerCase()
                                    )
                                }
                                value={formData[item.name] || undefined}
                                onChange={(value) =>
                                  handleChange(item.name, value)
                                }
                                options={item.options}
                              />
                            )}
                          </div>
                        </div>
                      ) : null}
                    </>
                  ))}
                </div>
              </div>
            </div>
            <div className="multiformfooter">
              <Formfooter />
            </div>
          </div>
        );
      // ... add more cases for additional steps
      default:
        return null;
    }
  };
  const [jsonList, setJsonList] = useState([]);
  const initialData = {
    name: "Employee Update",
    link: "/employee_creation",
    active: "no",
  };

  // useEffect to add initial data to the JSON list
  useEffect(() => {
    Tabhelper(initialData, setJsonList);
  }, []);

  //

  async function fetchReferenceData() {
    try {
      const response = await axios.get(apiurl + "reference/");
      setreferencedata(response.data);
    } catch (error) {
      alert("Network error");
    }
  }
  async function fetchData() {
    try {
      const response = await axios.get(apiurl + `staffdetails/${Id}/`);
      //   settotalcount(response.data.length);
      //   setsnonumber(response.data.length + 289);
      //   handleChange("sno", response.data.length + 289);

      setFormData(response.data);
    } catch (error) {
      alert("Network error");
    }
  }
  const generateID = (event) => {
    if (
      formData.first_name == "" ||
      formData.last_name == "" ||
      formData.date_of_birth == ""
    ) {
      alert("Please Enter All the Required Data..!");
    } else {
      event.preventDefault();
      const current = new Date();
      const date2 = `${current.getDate()}/${
        current.getMonth() + 1
      }/${current.getFullYear()}`;
      let [d, m, y] = date2.split(/\D/);
      const date = new Date(y, --m, d);
      const fullyear = date.getFullYear();
      const number = totalcount + 10;
      const paddedNumber = number.toString().padStart(4, "0");
      const sid = "CBC" + paddedNumber;
      console.log();
      // setstudentid(sid);

      //   setFormData((prevState) => ({
      //     ...prevState,
      //     Name: `${prevState.first_name.toUpperCase()} ${prevState.last_name.toUpperCase()}`,
      //   }));
      setisverified(true);

      handleChange("Staffid", sid);
    }
  };

  useEffect(() => {
    fetchData();
    fetchReferenceData();
  }, []);

  return (
    <Maincomponent tabname={"Employee Update"}>
      <div className="component-sub">
        <div className="registercomp1">
          {show == false ? <>{renderStep()}</> : null}
        </div>
        {/* <button onClick={generateID}>Test</button> */}
      </div>
    </Maincomponent>
  );
}
